<nav class="main-nav">
  <ul *ngIf='tabs'>
    <li *ngFor="let tab of tabs.getTabs()">
      <a [class.active]="isTabActive(tab)" title="{{ tab.name }}" (click)="tab.switch()">{{ tab.name | langf }}</a>
    </li>
  </ul>
</nav>
